import React from "react";

import { RoutePaths } from "src/app/model";

export const pages: {
  label: React.ReactNode;
  value: RoutePaths;
}[] = [
  {
    label: "Home",
    value: RoutePaths.HOME,
  },
  {
    label: "About Us",
    value: RoutePaths.ABOUT_US,
  },
  {
    label: "Services",
    value: RoutePaths.SERVICES,
  },
  {
    label: "Projects",
    value: RoutePaths.PROJECTS,
  },
  {
    label: "Tools",
    value: RoutePaths.TOOLS,
  },
  // {
  //   label: "Blogs",
  //   value: RoutePaths.BLOGS,
  // },
  {
    label: "Contact",
    value: RoutePaths.CONTACTS,
  },
];
